import { AXIOS_INSTANCE } from ".";
import {
  BASE_URL,
  CASINO_SERVICE_URL,
  CRICKET_SERVICE_URL,
  getToken,
} from "../utils/constants";

export const loginAPI = async (username, password, isDemo = false) => {
  if (isDemo) {
    try {
      const { data } = await AXIOS_INSTANCE.post(
        `${BASE_URL}/auth/demo-signin`,
        {
          username,
          password,
        }
      );
      return data;
    } catch (error) {
      return error;
    }
  } else {
    try {
      const { data } = await AXIOS_INSTANCE.post(`${BASE_URL}/auth/signin`, {
        username,
        password,
      });
      return data;
    } catch (error) {
      return error;
    }
  }
};
export const registerAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${BASE_URL}/auth/signup`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getProfitLossAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${BASE_URL}/user/event-profit-loss-report`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const changePasswordAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.put(
      `${BASE_URL}/auth/password`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const checkValidEmailAPI = async (email) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${BASE_URL}/auth/valid/email/${email}`
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const checkValidUsernameAPI = async (username) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${BASE_URL}/auth/valid/username/${username}`
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const getUserByIdAPI = async (id) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(`${BASE_URL}/auth/user/${id}`);
    return data;
  } catch (error) {
    return error;
  }
};

export const getButtonValuesAPI = async () => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${BASE_URL}/user/client-button2`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const changeButtonValuesAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.put(
      `${BASE_URL}/user/update-client-button2`,
      {
        ...payload,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const betHistoryAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${BASE_URL}/user/bet-history`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const betGetHistoryAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(`${BASE_URL}/user/bet-history`, {
      params: {
        ...payload,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};
export const newBetGetHistoryAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(`${BASE_URL}/user/bet-list`, {
      ...payload,
    });
    return data;
  } catch (error) {
    return error;
  }
};
export const getProfitLossReportAPI = async (from, to, userName) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${BASE_URL}/user/profit-loss-report`,
      {
        from,
        to,
        userName,
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const unSetteledBetsAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${BASE_URL}/user/unsettled-bets`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const profitLossReportAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${BASE_URL}/user/profit-loss-report`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const currentBetsAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${BASE_URL}/user/current-bets`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getActivityLogAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${BASE_URL}/user/activity-log`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getExposureTableAPI = async () => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${BASE_URL}/user/exposure-table`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const searchAPI = async (search) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${BASE_URL}/user/home-page/search`,
      {
        params: {
          search,
        },
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const scoreAPI = async (eventId) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `http://marketsarket.in:3002/scoreurl/${eventId}`
    );
    return data?.score;
  } catch (error) {
    return error;
  }
};

export const getMatchScoreAPI = async (eventId) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${BASE_URL}/auth/score-sport`,
      {},
      {
        params: {
          eventId,
        },
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const upcomingFixtureAPI = async () => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${BASE_URL}/auth/upcoming-fixture`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const dashboardBannerAPI = async () => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${BASE_URL}/auth/dashboard-banner`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const getAnnouncementAPI = async () => {
  try {
    const { data } = await AXIOS_INSTANCE.get(`${BASE_URL}/auth/announcement`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveStreamingUrlAPI = async (id) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${BASE_URL}/auth/streaming/${id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getBetsFromAccountLogs = async (id) => {
  console.log(id);
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${BASE_URL}/user/bets-from-log`,
      {
        params: {
          accountLogId: id,
        },
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getAccountStatementAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${BASE_URL}/accmanage/account-log`,
      {
        ...payload,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const getSportsScoreAPI = async (id) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${BASE_URL}/auth/score-sport-v2/${id}`
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getCoinHistoryAPI = async (id) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(`${BASE_URL}/user/coin-history`);
    return data;
  } catch (error) {
    return error;
  }
};


export const casinoBetAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${CASINO_SERVICE_URL}/bet/place`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const getCompleteGamesAPI = async () => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${BASE_URL}/user/completed-games`
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const getCurrentBetsAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${BASE_URL}/user/current-bets`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};